<div style="padding: 30px">
    <mat-icon>info</mat-icon>
    <mat-label class="notesHeader">CORS (Cross-Origin Resource Sharing)</mat-label>
    <br/>
    <mat-divider></mat-divider>
    <br/>
    <br/>
    <ol>
        <li>
            For the Web / HTML / Social / external link components, to be successfully embedded in your presentation,
            be sure to install this Chrome X-Frame extension. This will assist in resolving the common pitfall of Cross-Origin Resource Sharing (CORS) error which is common in web deployment, due to security restrictions of some web sites.
            Note that this extension is available for Linux, Windows and Mac OS.
            <br/>
            <br/>
            <a style="margin: 8px" (click)="getFrameExt()" color="accent" mat-raised-button>
                {{ 'general.downloadExtension' | transloco }}
            </a>
        </li>
        <br/>
        <li>
            For final SignPlayer deployment be sure to install the Windows, Linux or Mac WatchDog (Available from the Download section of the SignStudio).
            This will assist in resolving most CORS issues.
        </li>
        <br/>
        <li>
            Note that in order to keep Social components (Facebook, Instagram, X, TikTok etc) working, you must keep them in your digital signage presentation.
            Inactivity for more than 30 days, will result in automatically removal of the connection to the social network; this is due to licensing requirements.
        </li>
        <br/>
    </ol>
    <br/>
    <mat-divider></mat-divider>
    <br/>
</div>
